"use client";
import React, { useState } from "react";

import defaultStyles from "@stadium/ui/src/components/SliderDropdown/main.module.scss";

//To use SliderDropdown, wrap your component with the SliderContainer present in the "./container.js" file.

const SliderDropdown = ({
  label,
  backLabel = label,
  children,
  className = "",
  styles = defaultStyles,
  onLabelClick,
  allowFullWidthClick = true,
  onBackLabelClick,
  ariaLabel = "slider dropdown",
}) => {
  const [activeClass, setActiveClass] = useState("");

  const handleClick = (evt) => {
    onLabelClick?.(evt);
    setActiveClass(styles.slideIn);
  };

  return (
    <div className={styles.menuContainerLi}>
      {children ? (
        <>
          <div
            className={`${styles.sliderDropdownItem} ${styles.menuClickNext}`}
            onClick={allowFullWidthClick ? handleClick : null}
            aria-label={ariaLabel}
          >
            {label} <button className={styles.nextIcon} onClick={handleClick} />
          </div>
          <div className={`${styles.menuContainerSlide} ${activeClass} ${className}`}>
            <div className={styles.menuContainerLi}>
              <div
                onClick={() => {
                  setActiveClass("");
                  onBackLabelClick?.();
                }}
                className={`${styles.sliderDropdownItem} ${styles.menuClickBack}`}
              >
                {backLabel}
              </div>
            </div>
            {children}
          </div>
        </>
      ) : (
        <div className={styles.sliderDropdownItem}>{label}</div>
      )}
    </div>
  );
};

export default SliderDropdown;
